import React, { useEffect, useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import styles from './navbar.module.css';

import { useCookies } from '../../../../hooks/useCookies';
import * as profileAction from '../../../../actions/Profile';

export default function Navbar({ style }) {
    const navigate = useNavigate();
    const location = useLocation();
    const cookies = useCookies();
    const { getCookie, setCookie } = cookies;

    const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);
    const [isRejected, setIsRejected] = useState(false);

    const currentPath = location.pathname;
    const suffix = currentPath.split("/").at(-1);

    // Fetch profile images


    // Handle window resizing for mobile detection
    useEffect(() => {
        const handleResize = () => {
            setIsMobile(window.innerWidth <= 768);
        };

        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    }, []);

    // Fetch profile images on mount


    // Approval check logic
    useEffect(() => {
        if (currentPath === "/user/pause") return;

        (async () => {
            const result = await profileAction.checkApproval();
            if (result) {
                setCookie('approval', result?.approval);
                setCookie('active', result?.active);
                setIsRejected(!result?.active);

                if (!result?.active) {
                    window.location.replace("/user/pause");
                }
            }
        })();
    }, [currentPath]);

    // Icons Components
    const Icons = {
        Home: ({ active }) => (
            active ? (
                <svg width="24" height="24" viewBox="0 0 24 24" fill="url(#navGradient)" xmlns="http://www.w3.org/2000/svg">
                    <path d="M3 10.12a2 2 0 0 1 .74-1.55L10.32 3.7a2.6 2.6 0 0 1 3.36 0l6.58 4.87a2 2 0 0 1 .74 1.55V19a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-8.88z"/>
                    <path d="M9 21v-4a3 3 0 0 1 6 0v4" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                </svg>
            ) : (
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M3 10.12a2 2 0 0 1 .74-1.55L10.32 3.7a2.6 2.6 0 0 1 3.36 0l6.58 4.87a2 2 0 0 1 .74 1.55V19a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-8.88z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                    <path d="M9 21v-4a3 3 0 0 1 6 0v4" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                </svg>
            )
        ),
        Matches: ({ active }) => (
            active ? (
                <svg width="24" height="24" viewBox="0 0 24 24" fill="url(#navGradient)" xmlns="http://www.w3.org/2000/svg">
                     <path d="M7 21l-3.2 1.2c-.3.1-.6-.2-.5-.5l1.2-3.2C3.1 16.6 2 14.4 2 12c0-5.5 4.5-10 10-10s10 4.5 10 10-4.5 10-10 10c-1.8 0-3.5-.5-5-1.5z"/>
                     <circle cx="8" cy="12" r="1" fill="white"/>
                     <circle cx="12" cy="12" r="1" fill="white"/>
                     <circle cx="16" cy="12" r="1" fill="white"/>
                </svg>
            ) : (
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M7 21l-3.2 1.2c-.3.1-.6-.2-.5-.5l1.2-3.2C3.1 16.6 2 14.4 2 12c0-5.5 4.5-10 10-10s10 4.5 10 10-4.5 10-10 10c-1.8 0-3.5-.5-5-1.5z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                    <circle cx="8" cy="12" r="1.2" fill="currentColor"/>
                    <circle cx="12" cy="12" r="1.2" fill="currentColor"/>
                    <circle cx="16" cy="12" r="1.2" fill="currentColor"/>
                </svg>
            )
        ),
        Profile: ({ active }) => (
            active ? (
                <svg width="24" height="24" viewBox="0 0 24 24" fill="url(#navGradient)" xmlns="http://www.w3.org/2000/svg">
                    <circle cx="12" cy="7" r="5"/>
                    <path d="M12 14c-5.33 0-10 2.67-10 6v1a1 1 0 001 1h18a1 1 0 001-1v-1c0-3.33-4.67-6-10-6z"/>
                </svg>
            ) : (
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <circle cx="12" cy="7" r="4" stroke="currentColor" strokeWidth="2"/>
                    <path d="M4 21c0-3.314 3.582-6 8-6s8 2.686 8 6" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
                </svg>
            )
        ),
        Settings: ({ active }) => (
            active ? (
                <svg width="24" height="24" viewBox="0 0 24 24" fill="url(#navGradient)" xmlns="http://www.w3.org/2000/svg">
                    <path d="M19.4 15a1.65 1.65 0 00.33 1.82l.06.06a2 2 0 11-2.83 2.83l-.06-.06a1.65 1.65 0 00-1.82-.33 1.65 1.65 0 00-1 1.51V21a2 2 0 11-4 0v-.09A1.65 1.65 0 009 19.4a1.65 1.65 0 00-1.82.33l-.06.06a2 2 0 11-2.83-2.83l.06-.06a1.65 1.65 0 00.33-1.82 1.65 1.65 0 00-1.51-1H3a2 2 0 110-4h.09A1.65 1.65 0 004.6 9a1.65 1.65 0 00-.33-1.82l-.06-.06a2 2 0 112.83-2.83l.06.06a1.65 1.65 0 001.82.33H9a1.65 1.65 0 001-1.51V3a2 2 0 114 0v.09a1.65 1.65 0 001 1.51 1.65 1.65 0 001.82-.33l.06-.06a2 2 0 112.83 2.83l-.06.06a1.65 1.65 0 00-.33 1.82V9a1.65 1.65 0 001.51 1H21a2 2 0 110 4h-.09a1.65 1.65 0 00-1.51 1z"/>
                    <circle cx="12" cy="12" r="3" fill="white"/>
                </svg>
            ) : (
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M12 15a3 3 0 100-6 3 3 0 000 6z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                    <path d="M19.4 15a1.65 1.65 0 00.33 1.82l.06.06a2 2 0 010 2.83 2 2 0 01-2.83 0l-.06-.06a1.65 1.65 0 00-1.82-.33 1.65 1.65 0 00-1 1.51V21a2 2 0 01-2 2 2 2 0 01-2-2v-.09A1.65 1.65 0 009 19.4a1.65 1.65 0 00-1.82.33l-.06.06a2 2 0 01-2.83 0 2 2 0 010-2.83l.06-.06a1.65 1.65 0 00.33-1.82 1.65 1.65 0 00-1.51-1H3a2 2 0 01-2-2 2 2 0 012-2h.09A1.65 1.65 0 004.6 9a1.65 1.65 0 00-.33-1.82l-.06-.06a2 2 0 010-2.83 2 2 0 012.83 0l.06.06a1.65 1.65 0 001.82.33H9a1.65 1.65 0 001-1.51V3a2 2 0 012-2 2 2 0 012 2v.09a1.65 1.65 0 001 1.51 1.65 1.65 0 001.82-.33l.06-.06a2 2 0 012.83 0 2 2 0 010 2.83l-.06.06a1.65 1.65 0 00-.33 1.82V9a1.65 1.65 0 001.51 1H21a2 2 0 012 2 2 2 0 01-2 2h-.09a1.65 1.65 0 00-1.51 1z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                </svg>
            )
        )
    };

    return (
        <nav className={styles.nav} style={style}>
            <svg width="0" height="0" className="absolute hidden">
                <defs>
                    <linearGradient id="navGradient" x1="0%" y1="0%" x2="0%" y2="100%">
                        <stop offset="-4.17%" stopColor="#FC8C66" />
                        <stop offset="110.42%" stopColor="#F76A7B" />
                    </linearGradient>
                </defs>
            </svg>
            <ul>
                {/* Home */}
                <li
                    className={`${styles.navItem} ${suffix === "home" ? styles.active : ""}`}
                    onClick={() => !isRejected && navigate("/user/home")}
                >
                    <Icons.Home active={suffix === "home"} />
                    <div className={styles.indicator}></div>
                </li>

                {/* Matches */}
                <li
                    className={`${styles.navItem} ${currentPath.includes("chat") ? styles.active : ""}`}
                    onClick={() => !isRejected && navigate("/user/chat/matches")}
                >
                    <Icons.Matches active={currentPath.includes("chat")} />
                    <div className={styles.indicator}></div>
                </li>

                {/* Profile */}
                <li
                    className={`${styles.navItem} ${suffix === "updateprofile" ? styles.active : ""}`}
                    onClick={() => navigate("/updateprofile")}
                >
                    <Icons.Profile active={suffix === "updateprofile"} />
                    <div className={styles.indicator}></div>
                </li>

                {/* Settings */}
                <li
                    className={`${styles.navItem} ${suffix === "accoutsetting" ? styles.active : ""}`}
                    onClick={() => navigate("/accoutsetting")}
                >
                    <Icons.Settings active={suffix === "accoutsetting"} />
                    <div className={styles.indicator}></div>
                </li>
            </ul>
        </nav>
    );
}
